import script from "./BotFlows.vue?vue&type=script&lang=ts&setup=true"
export * from "./BotFlows.vue?vue&type=script&lang=ts&setup=true"

import "./BotFlows.vue?vue&type=style&index=0&id=15185880&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15185880"]])

export default __exports__